import { Inbox, InboxContent } from "@novu/react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Config from "~/config/env";
import { appearance } from "~/components/notifications/appearance";
import {
  getPathFromNotification,
  HSPNotification,
} from "~/components/notifications/utils";

// const subscriberId = "novu_fa356233-91d5-4ac4-9d3e-d92b1366c263";
// const applicationIdentifier = "C8p8iAqchvwx";

export function NovuInbox() {
  const navigate = useNavigate();

  const subscriberId = useSelector((state) => state.login.subscriber);
  const applicationIdentifier = Config.NOVU_APP_IDENTIFIER;

  const navigationHandler = (notification: Notification) => {
    const path = getPathFromNotification(notification as HSPNotification);
    navigate(path);
  };

  return (
    <Inbox
      applicationIdentifier={applicationIdentifier}
      subscriber={subscriberId}
      appearance={appearance}
      routerPush={(path: string) => {
        navigate(path);
      }}
    >
      <InboxContent onNotificationClick={navigationHandler} />
    </Inbox>
  );
}
